import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { map, Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import QRCodeStyling from "qr-code-styling";

@Component({
  standalone: true,
  selector: "app-widget",
  templateUrl: "./widget.component.html",
  styleUrls: ["./widget.component.scss"],
  imports: [CommonModule],
  providers: [],
})
export class WidgetComponent implements OnInit, AfterViewInit, OnDestroy {
  public qrCodeTitle = "";
  public qrCodeUrl = "";
  public qrCodeImage = "";
  public currentMessageIndex = 0;
  public siteUrl = environment.siteUrl.replace(/^https?:\/\//, ''); // Remove http:// ou https://
  public atName = "";
  private type = "";
  private masterSubscription = new Subscription();
  private messageInterval: any;
  private qrCode: QRCodeStyling | null = null;
  @ViewChild("qrCanvas", { static: false })
  qrCanvas!: ElementRef<HTMLDivElement>;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngAfterViewInit() {
    // Inicializar o QR Code após a view estar pronta
    this.initQRCode();
  }

  ngOnInit() {
    this.masterSubscription.add(
      this.activatedRoute.paramMap
        .pipe(
          map((params) => {
            this.atName = params.get("atname") || "";
            this.type = params.get("type") || "";
          })
        )
        .subscribe(() => {
          if (this.type === "donation") {
            this.qrCodeUrl = `${environment.siteUrl}/${this.atName}/donate`;
          } else if (this.type === "sale") {
            this.qrCodeUrl = `${environment.siteUrl}/${this.atName}`;
          }
          this.qrCodeTitle = `${environment.siteUrl}/${this.atName}`;
          
          // Atualizar QR Code se já foi inicializado
          if (this.qrCode) {
            this.qrCode.update({ data: this.qrCodeUrl });
          }
        })
    );
    
    // Iniciar rotação de mensagens
    this.startMessageRotation();
  }

  ngOnDestroy(): void {
    this.masterSubscription.unsubscribe();
    
    // Limpar interval
    if (this.messageInterval) {
      clearInterval(this.messageInterval);
    }
  }

  private initQRCode(): void {
    const qrWrapper = this.qrCanvas.nativeElement.querySelector('.qr-code-canvas-wrapper');
    if (!qrWrapper || !this.qrCodeUrl) return;

    this.qrCode = new QRCodeStyling({
      width: 250,
      height: 250,
      data: this.qrCodeUrl,
      margin: 5,
      qrOptions: {
        typeNumber: 0,
        mode: 'Byte',
        errorCorrectionLevel: 'H'
      },
      imageOptions: {
        hideBackgroundDots: true,
        imageSize: 0.35,
        margin: 3
      },
      dotsOptions: {
        type: 'rounded',
        color: '#000000ff',
        gradient: undefined
      },
      backgroundOptions: {
        color: '#ffffff',
      },
      image: 'assets/images/logo_index.png',
      cornersSquareOptions: {
        type: 'extra-rounded',
        color: '#000000ff'
      },
      cornersDotOptions: {
        type: 'dot',
        color: '#000000ff'
      }
    });

    this.qrCode.append(qrWrapper as HTMLElement);
  }

  private startMessageRotation(): void {
    this.messageInterval = setInterval(() => {
      this.currentMessageIndex = (this.currentMessageIndex + 1) % 3;
    }, 3500); // Troca a cada 3.5 segundos
  }
}
